import registerSidebarStatusmapDirective from './SidebarStatusmapDirective';
import { registerSidebarDirective, registerSidebarHeightDirective } from './SidebarDirective';
import registerSidebarQuestionlistDirective from './SidebarQuestionlistDirective';
import SidebarStatusmapOverviewController from './SidebarStatusmapOverviewDirective';
import SidebarQuestionlistController from './SidebarQuestionlistController';
import registerSidebarBackgroundDirective from './SidebarBackgroundDirective';


export default function registerSidebarComponents(angular) {
    const assessmentFrontendDirectives = angular.module('assessmentFrontendDirectives');
    const assessmentFrontendControllers = angular.module('assessmentFrontendControllers');

    registerSidebarStatusmapDirective(
        assessmentFrontendDirectives,
        '/views/ib/modules/sidebar/SidebarStatusmap.html',
        'SidebarController'
    );
    registerSidebarQuestionlistDirective(assessmentFrontendDirectives);
    registerSidebarDirective(assessmentFrontendDirectives);
    registerSidebarHeightDirective(assessmentFrontendDirectives);
    registerSidebarBackgroundDirective(assessmentFrontendDirectives);

    assessmentFrontendControllers.controller('SidebarQuestionlistController', [
        '$injector', '$rootScope', '$scope', '$location', '$signals', '$routeParams', '$timeout', '$translate',
        function($injector, $rootScope, $scope, $location, $signals, $routeParams, $timeout, $translate) {
            return new SidebarQuestionlistController($injector, $rootScope, $scope, $location, $signals, $routeParams, $timeout, $translate);
        }
    ]);

    assessmentFrontendDirectives.directive('statusmapOverview', ['$compile', '$signals', '$translate',
        function($compile, $signals, $translate) {
            return {
                restrict: 'E',
                replace: true,
                scope: {
                    task: '=',
                    sortby: '='
                },
                templateUrl: '/views/ib/modules/sidebar/SidebarStatusMapOverview.html',
                controller: 'SidebarController',
                link: function(scope, element, attrs) {
                    new SidebarStatusmapOverviewController(scope, $compile, $signals, $translate).link(scope, element, attrs);
                }
            };
        }
    ]);
}